import React, { useState } from 'react';
import {
  signIn,
  fetchUserAttributes,
  confirmSignIn,
  fetchAuthSession,
  signOut,
} from 'aws-amplify/auth';
import { BUTTON_TEXT } from 'global-constants/constants';
import * as Sentry from '@sentry/react';

import LayoutView from '../../Common/LayoutView';
import LoginLeftPanel from '../LoginLeftPanel/LoginLeftPanel';
import EmailLogin from '../LoginRightPanel/EmailLogin';
import CreatePasswordComponent from '../LoginRightPanel/CreatePassword';
import OtpVerfication from '../LoginRightPanel/OtpVerification';
import { roleSpecificUserData } from '../LoginHelper';
import styles from './LoginComponent.module.scss';

const AMPLIFY_NEXTSTEP = {
  NEW_PASSWORD: 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
  SMS_CODE: 'CONFIRM_SIGN_IN_WITH_SMS_CODE',
  DONE: 'DONE',
};

const LoginComponent = () => {
  const [showChallengeView, setshowChallengeView] = useState(false);
  const [challengeName, setChallengeName] = useState('login');
  const [buttonText, setButtonText] = useState(BUTTON_TEXT.login);
  const [loading, setLoading] = useState(false);
  const [newPassword, setChangeNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isChangePass, setIsChangePass] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [values, setValues] = useState({
    mobile: '',
    password: '',
    otp: '',
  });
  const [createFormError, setCreateFormError] = useState();
  const [loginFormError, setLoginFormError] = useState();

  const handleChange = (name) => (event) => {
    setLoginFormError();
    setValues({ ...values, [name]: event?.target?.value?.trim() });
  };

  const handleChangepasswordRequest = async (event) => {
    event.preventDefault();

    setCreateFormError();
    setIsChangePass(true);

    try {
      const data = await confirmSignIn({
        challengeResponse: newPassword.trim(),
      });

      if (data?.nextStep?.signInStep !== AMPLIFY_NEXTSTEP.DONE) throw data;

      await signOut();

      setshowChallengeView(false);
    } catch (err) {
      setCreateFormError(
        err?.message ||
          err?.error ||
          'Error while updating password. Please try again in sometime',
      );
    }

    setIsChangePass(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setButtonText(BUTTON_TEXT.validating);
      const data = await signIn({
        username: values.mobile.replace(/\s/g, ''),
        password: values.password.trim(),
      });

      const cName = data?.nextStep?.signInStep;

      if (
        cName === AMPLIFY_NEXTSTEP.NEW_PASSWORD ||
        cName === AMPLIFY_NEXTSTEP.SMS_CODE
      ) {
        setChallengeName(cName);
        setshowChallengeView(true);
        setLoading(false);
        setButtonText(BUTTON_TEXT.login);

        return;
      }

      if (data?.isSignedIn) {
        const authSession = await fetchAuthSession({ forceRefresh: true });
        const { idToken = {} } = authSession?.tokens ?? {};
        const jwtToken = idToken.toString() || '';

        localStorage.setItem('subscribiliToken', jwtToken);

        localStorage.setItem(
          'tokenValidity',
          new Date().getTime() + 1000 * 60 * 60 * 5,
        ); // 5 hours

        const userInfo = await fetchUserAttributes();
        await roleSpecificUserData(userInfo);

        const pathName = new URLSearchParams(window.location.search).get(
          'redirect',
        );
        if (pathName) {
          window.location = decodeURIComponent(pathName);
        } else {
          window.location = '/dashboard';
        }
      } else {
        throw new Error({ message: 'Unable to login user' });
      }
    } catch (err) {
      Sentry.captureException(err);
      err?.message && Sentry.captureMessage(err.message);

      setLoading(false);
      setButtonText(BUTTON_TEXT.login);

      let message = err?.message;
      if (err.message === 'User does not exist.')
        message = 'Incorrect username or password.';

      setLoginFormError(message);
    }
  };

  const renderRightPanel = () => {
    if (!showChallengeView) {
      return (
        <EmailLogin
          showPassword={showPassword}
          values={values}
          handleChange={handleChange}
          setShowPassword={setShowPassword}
          loading={loading}
          buttonText={buttonText}
          handleLogin={handleLogin}
          formSubmitError={loginFormError}
          setFormSubmitError={setLoginFormError}
        />
      );
    } else if (challengeName === AMPLIFY_NEXTSTEP.NEW_PASSWORD) {
      return (
        <CreatePasswordComponent
          newPassword={newPassword}
          setChangeNewPassword={setChangeNewPassword}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
          handleChangepasswordRequest={handleChangepasswordRequest}
          isChangePass={isChangePass}
          setshowChallengeView={setshowChallengeView}
          formSubmitError={createFormError}
          setFormSubmitError={setCreateFormError}
        />
      );
    } else {
      return (
        <OtpVerfication handleChange={handleChange} handleLogin={handleLogin} />
      );
    }
  };

  return (
    <>
      <LayoutView.DocumentTitle title={'Login'} />

      <div className={styles.loginPage}>
        <LoginLeftPanel />
        {renderRightPanel()}
      </div>
    </>
  );
};

export default LoginComponent;
